import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledProductsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StyledProductItem = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    text-decoration: none;

    &:not(:last-child) {
        padding-bottom: 8px;
        border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    }
`;
